import * as React from "react";
import Container from "../../common/Container";
import { Dropdown, MenuProps, Table, TablePaginationConfig } from "antdv5";
import type { ColumnsType } from "antdv5/es/table";
import {
  DownOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { color } from "../../../styles/color";
import { SetState, Fn, Obj } from "../../../client_types";
import ScanDetailStyledTable from "styles/ScanDetailTable";

interface IPageInfo {
  pageSize: number | string;
  current: number | string;
}

interface IProps {
  columns: ColumnsType<Obj>;
  data: {
    data: any[];
    count: number | string;
  };
  sortText: string;
  loading: boolean;
  pageInfo: IPageInfo;
  className?: string;
  setLockInput: SetState<boolean>;
  setLock: SetState<boolean>;
  handleDownload: () => Promise<void>;
  handleCurrentPage: () => number | undefined;
  onTableChange: (pagination: TablePaginationConfig) => void;
  fetchNewData: (pageSize: number, current: number) => void;
  preventRefreshCount: (fn: Fn, count: number) => void;
  fakePreventRefresh: () => false;
  handleMenuClick: MenuProps["onClick"];
}

const items: MenuProps["items"] = [
  {
    key: "1",
    label: "排名(正序)",
    icon: <CaretDownOutlined />,
  },
  {
    key: "2",
    label: "排名(倒序)",
    icon: <CaretUpOutlined />,
  },
];

const ScanDetailTable = ({
  columns,
  data,
  sortText,
  className = "",
  handleDownload,
  fetchNewData,
  preventRefreshCount,
  setLockInput,
  setLock,
  handleCurrentPage,
  onTableChange,
  loading,
  pageInfo,
  fakePreventRefresh,
  handleMenuClick,
}: IProps) => {
  return (
    <Container>
      <ScanDetailStyledTable
        className={className}
        columns={columns}
        dataSource={data.data}
        pagination={
          // let pagination object be empty if
          // no data, hides pagination panel like
          // the original
          data.data.length === 0
            ? {
                // read below
                defaultPageSize: 100,
              }
            : {
                pageSizeOptions: ["20", "50", "100"],
                locale: { items_per_page: "笔/页" },
                // defaultPageSize MUST be equal (or larger) to length of dataSource,
                // otherwise the table won't show all data
                defaultPageSize: data.data.length,
                total: typeof data.count === "string" ? 1 : data.count,
                showTotal: () => (
                  <div className="showTotal">
                    <Dropdown
                      trigger={["click"]}
                      menu={{ items, onClick: handleMenuClick }}
                    >
                      <button>
                        {sortText} <DownOutlined />
                      </button>
                    </Dropdown>
                    <button
                      onClick={() => {
                        fetchNewData(
                          typeof pageInfo.pageSize === "string"
                            ? Number.parseInt(pageInfo.pageSize)
                            : pageInfo.pageSize,
                          typeof pageInfo.current === "string"
                            ? Number.parseInt(pageInfo.current)
                            : pageInfo.current
                        );
                        preventRefreshCount(fakePreventRefresh, 3);
                        setLockInput(true);
                        setLock(true);
                      }}
                    >
                      刷新
                    </button>
                    {localStorage.getItem("onAuth") === "true" ? (
                      <button
                        style={{
                          backgroundColor: "white",
                          color: color.markedSecondary,
                        }}
                        onClick={handleDownload}
                        disabled={data.data.length === 0}
                      >
                        下载
                      </button>
                    ) : null}
                    <div style={{ color: `${color.primaryBlue}` }}>
                      共 {data.data.length > 0 ? data.data[0].ClubCount : "0"}{" "}
                      舍 {data.count ? data.count : "0"} 鸽
                    </div>
                  </div>
                ),
                showQuickJumper: true,
                current: handleCurrentPage(),
                position: ["topRight", "bottomRight"],
                responsive: true,
              }
        }
        onChange={onTableChange}
        scroll={{ x: "max-content" }}
        rowKey="id"
        loading={loading}
        sticky
        size={"small"}
        bordered
      />
    </Container>
  );
};

export default ScanDetailTable;
